import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  selectSingleElement,
  selectMultipleElements,
  setKeyElement,
  deleteImage,
  updateImageSize,
  setElementDimensions,
  verifyElementsLoaded,
  validateElement,
  validateDesign,
} from "../../../../../../actions";
import DeleteElementButton from "../DeleteElementButton";
// import ImageWrap from './ImageWrap'
import UserArt from "./UserArt";
// import SelectSize from './SelectSize'

class Image extends React.Component {
  state = {
    width: null,
    height: null,
  };

  onHandleClick = (event) => {
    if (this.props.disableInteractivity) {
      return false;
    }

    const id = this.props.imageElement.id,
          selectedValue = !this.props.imageElement.is_selected;

    if (this.props.activeTool === "Align") {
      // Count the number of selected elements
      const selectedElementsCount =
        this.props.layer.text_elements.filter(el => el.is_selected).length +
        this.props.layer.image_elements.filter(el => el.is_selected).length,
        keyElementValue = !this.props.imageElement.is_key_element,
        isSelected = this.props.imageElement.is_selected;

      if (isSelected && selectedElementsCount > 1) {
        this.handleSetKeyElement(id, keyElementValue);
      } else if (event.shiftKey) {
        // Shift click to select multiple elements
        this.handleSelectMultipleElements(id, selectedValue);
      } else {
        // Regular click to select single element
        this.handleSelectSingleElement(id, selectedValue);
      }
  } else {
      if (event.shiftKey) {
        // Shift click to select multiple elements
        this.handleSelectMultipleElements(id, selectedValue);
      } else {
        // Regular click to select single element
        this.handleSelectSingleElement(id, selectedValue);
      }
  }
};

  handleSelectSingleElement = (id, value) => {
    this.props.selectSingleElement({
      id,
      value,
      index: this.props.index,
      layerId: this.props.layerId,
      itemType: this.props.itemType,
    });

    if (!this.props.didShow2ndTip) {
      this.props.onShow2ndTip();
    }
  };

  handleSelectMultipleElements = (id, value) => {
    this.props.selectMultipleElements({
      id,
      value,
      index: this.props.index,
      layerId: this.props.layerId,
      itemType: this.props.itemType,
    });

    if (!this.props.didShow2ndTip) {
      this.props.onShow2ndTip();
    }
  };

  handleSetKeyElement = (id) => {
    this.props.setKeyElement({
      id,
      index: this.props.index,
      layerId: this.props.layerId,
      itemType: this.props.itemType,
    });
  };

  onDeleteImage = () => {
    const id = this.props.imageElement.id;
    this.props.deleteImage({
      id,
      index: this.props.index,
      layerId: this.props.layerId,
    });
    this.props.validateDesign();
  };

  onUpdateSize = (size) => {
    const id = this.props.imageElement.id;
    this.props.updateImageSize({
      id,
      index: this.props.index,
      layerId: this.props.layerId,
      size,
    });
  };

  onSetDimensions = (width, height) => {
    const scale = 72 * this.props.previewScale;

    this.setState({
      width: width / scale,
      height: height / scale,
    });

    this.props.setElementDimensions({
      index: this.props.index,
      layerId: this.props.layerId,
      width,
      height,
      itemType: this.props.itemType,
    });
  };

  handleRepositionAnchoredElement = (oldWidth, newWidth) => {
    this.props.repositionAnchoredElement({
      oldWidth,
      newWidth,
      index: this.props.index,
      layerId: this.props.layerId,
      itemType: this.props.itemType,
    });
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.imageElement.width !== this.props.imageElement.width ||
      prevProps.imageElement.height !== this.props.imageElement.height
    ) {
      if (this.props.imageElement.width && this.props.imageElement.height) {
        this.props.validateElement({
          index: this.props.index,
          layerId: this.props.layerId,
          itemType: this.props.itemType,
        });
      }
    }
  }

  render() {
    let imageElement = null;

    // if (this.props.imageElement.userart) {
    const imageLayer = this.props.design.layer_set.find(
        (layer) => layer.layer_id === this.props.layerId,
      ),
      layerWidth = imageLayer.width,
      layerHeight = imageLayer.height;

    imageElement = (
      <UserArt
        isSelected={this.props.imageElement.is_selected}
        width={this.props.imageElement.width}
        height={this.props.imageElement.height}
        topPosition={this.props.imageElement.top_position}
        leftPosition={this.props.imageElement.left_position}
        layerWidth={layerWidth}
        layerHeight={layerHeight}
        url={this.props.url}
        index={this.props.index}
        layerId={this.props.layerId}
        id={this.props.imageElement.id}
        type={this.props.imageElement.type}
        onVerifyElementLoaded={this.props.verifyElementsLoaded}
        resizing={this.props.resizing}
        handleIsResizing={this.props.handleIsResizing}
      />
    );
    // } else {
    //   imageElement = (
    //     <div>
    //       <ImageWrap
    //         url={this.props.url}
    //         onSetDimensions={this.onSetDimensions}
    //         onVerifyElementLoaded={this.props.verifyElementsLoaded}
    //         type={'clipart'}
    //         imageElement={this.props.imageElement}
    //         domNodeWidth={this.props.imageElement.width * (this.props.design.preview_scale * 72)}
    //         handleRepositionAnchoredElement={this.handleRepositionAnchoredElement}
    //       />

    //       {this.props.imageElement.is_selected && !this.props.disableInteractivity &&
    //       <SelectSize
    //         onUpdateSize={this.onUpdateSize}
    //         selectedSize={this.props.imageElement.size || this.props.design.default_image_size}
    //       />
    //       }
    //     </div>
    //   )

    // }

    const selected = this.props.imageElement.is_selected ? "selected" : "",
      selectDisabled = this.props.disableInteractivity ? "disabled" : "",
      keyElementClass = this.props.imageElement.is_key_element ? "key-element" : "";

    return (
      <div
        className={`image-element-wrapper ${selected} ${selectDisabled} ${keyElementClass}`}
        onClick={this.onHandleClick}
      >
        {this.props.imageElement.is_selected &&
          !this.props.disableInteractivity && (
            <DeleteElementButton onDelete={this.onDeleteImage} />
          )}
        {imageElement}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    design: state.design.present,
    previewScale: state.design.present.preview_scale,
    productOption: state.productOption,
    layer: ownProps.layer,
    activeTool: state.activeToolCollection.activeTool,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      selectSingleElement,
      selectMultipleElements,
      setKeyElement,
      deleteImage,
      updateImageSize,
      setElementDimensions,
      verifyElementsLoaded,
      validateElement,
      validateDesign,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Image);
